import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=08490da4&scoped=true"
var script = {}
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=08490da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08490da4",
  null
  
)

export default component.exports